export default {
  init() {
    $('.offices-slider').slick({
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      arrows: true,
      infinite: true,
      centerMode: true,
      variableWidth: true,
    });

    $('.client-wrap').mouseover(function(){
      $('.client-wrap').removeClass('light-client');
      $('.client-wrap').not(this).addClass('light-client');
    });

    $('.client-wrap').mouseout(function(){
      $('.client-wrap').removeClass('light-client');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-qs.js